import { Component, ViewChild } from '@angular/core';
import { NavParams, NavController, LoadingController, Slides, ToastController, ModalController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';
import { EventCatalogs } from '../../pages/event-catalogs/event-catalogs';
import { LoginPage } from '../../pages/login/login';
import { EventCart } from '../../pages/event-cart/event-cart';
import { Catalog } from '../../pages/event-catalogs/catalog/catalog';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'event-catalog',
  templateUrl: 'event-catalog.html'
})

export class EventCatalogComponent {
 	@ViewChild(Slides) slides: Slides;

	obs: any;
	obsListener: any;
	obsCatalog: any;
	obsRelatedCatalog: any;
	client: any;
	event: any;
	componentState: any;
	dataCatalogs: any;
	badgeCatalog: any = [];
	textTranslate: any;

  constructor(public eventProvider: EventData, public params: NavParams, public nav: NavController, public loadingCtrl: LoadingController, events: Events, translate: Translate, public db: Database, public toastCtrl: ToastController, public auth: AuthData, public modalCtrl: ModalController) {
		translate.translateGroup(['Cargando', 'Debe iniciar sesión antes de continuar'])
    .then(result => {
      this.textTranslate = result;
    });

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'catalog').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsCatalog = this.eventProvider.getCatalogsTop(this.client, this.event.id).subscribe(data => {
        if (data && this.componentState) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((value) => {
      this.dataCatalogs = false;

      if (this.obsRelatedCatalog) {
        this.obsRelatedCatalog.unsubscribe();
      }

      if (value) {
        // setTimeout(() => {
          value.forEach((catalog: any, key) => {
            this.obsRelatedCatalog = this.eventProvider.getCatalog(this.client, catalog.catalogId).subscribe((data: any) => {
              value[key] = data;
            });
          });

          this.dataCatalogs = value;
        // }, 1000);
      } else {
        this.dataCatalogs = false;
      }
    });

    events.subscribe('catalog:badge', (numberData) => {
      this.badgeCatalog = numberData;
    });

    // close de listener where logout user
    events.subscribe('client:logout', () => {
      this.closeListener();
    });
  }

	slideChanged() {

	}

  viewItem(catalog, addToPay=false) {
    this.nav.push(Catalog, {client: this.client, event: this.event, dataCatalog: catalog, addToPay: addToPay});
  }

  viewAll() {
    this.nav.push(EventCatalogs, {client: this.client, event: this.event});
  }

  viewCart() {
    if (!this.auth.getUser().isAnonymous) {
      this.nav.push(EventCart, {client: this.client, event: this.event});
    } else {
        let modal = this.modalCtrl.create(LoginPage, {client: this.client, event: this.event});
        modal.present();

        let toast = this.toastCtrl.create({
          message: this.textTranslate["Debe iniciar sesión antes de continuar"],
          duration: 5000,
          position: 'top'
        });
        toast.present();
    }
  }

  closeListener() {
    if (this.obsListener) {
      console.log('Se eliminan los observables de Catalogs');
      this.obsListener.unsubscribe();
    }
    if (this.obsCatalog) {
      this.obsCatalog.unsubscribe();
    }
    if (this.obsRelatedCatalog) {
      this.obsRelatedCatalog.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-catalog/event-catalog.ts